<template>
  <div class="mt-16 mb-16">
    <vxe-table size="mini" border ref="xTable1" :row-config="{useKey: true}" :data="tableData">
      <vxe-column width="30">
        <template #default>
          <span class="drag-btn">
            <a-icon type="unordered-list" />
          </span>
        </template>
        <template #header>
          <vxe-tooltip v-model="showHelpTip1" content="按住后可以上下拖动排序！" enterable>
            <i class="vxe-icon-question-circle-fill" @click="showHelpTip1 = !showHelpTip1"></i>
          </vxe-tooltip>
        </template>
      </vxe-column>
      <vxe-column field="name" title="名称" show-overflow></vxe-column>
      <vxe-column field="width">
        <template #header>
          <a-row justify="space-between" type="flex">
            <span>宽度</span>
            <a-button type="link" class="primary-link-btn fs-12" @click="resetWidth">重置</a-button>
          </a-row>
        </template>
        <template #default="{row}">
          <editable-cell :text="row.width" @change="onCellChange(row.field, 'width', $event)"/>
        </template>
      </vxe-column>
      <vxe-column field="showType" title="类型" width="80">
        <template #default="{row}">
          <a-select
            size="small"
            :disabled="false"
            :value="row.showType || 'DEFAULT'"
            style="width: 100%"
            @change="onCellChange(row.field, 'showType', $event)"
          >
            <a-select-option value="DEFAULT">默认</a-select-option>
            <a-select-option value="IMAGE">图片</a-select-option>
          </a-select>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EditableCell from "./table/editTableCell.vue";
import Sortable from 'sortablejs'

export default {
  components: {
    'editable-cell': EditableCell,
  },
  model: {
    prop: "formData",
    event: "input"
  },
  props: {
    formData: Array
  },
  data() {
    return {
      showHelpTip1: false,

      dialogVisible: false,
      rowFormData: {
        name: "",
        field: "",
        width: ""
      },
      tableData: [],
    };
  },
  computed:{
    ...mapGetters({
      currentTempIndex: "getCurrentTempIndex",
      tablePosition: "getCurrentTablePosition",
    }),
  },
  watch: {
    formData: {
      handler(val){
        const cloned = this.$deepclone(this.formData) || []
        cloned.forEach(v => {
          if (!v.showType) v.showType = 'DEFAULT'
        })
        this.tableData = cloned
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    // 重置宽度
    resetWidth() {
      this.tableData.forEach(v => {
        v.width = this.getItemWidth(this.tableData)
      })
      this.$emit("input", this.tableData);
      this.$emit("change", this.tableData);
    },
    rowDrop () {
      this.$nextTick(() => {
        const xTable = this.$refs.xTable1
        console.log(Sortable)
        this.sortable1 = Sortable.create(xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
          handle: '.drag-btn',
          onEnd: ({ newIndex, oldIndex }) => {
            const currRow = this.tableData.splice(oldIndex, 1)[0]
            this.tableData.splice(newIndex, 0, currRow)
            this.$emit("input", this.tableData);
            this.$emit("change", this.tableData);
          }
        })
      })
    },
    setTableFieldList(valList) {
      let arr = [];
      const newList = this.$deepclone(valList);
      // console.log(valList, 'valList---setTableFieldList')
      // console.log(this.tablePosition, 'valList---tablePosition');
      const itemWidth = this.getItemWidth(valList)
      if(valList && valList.length > 0){
        arr = valList.map((item, index) => {
          item.width = itemWidth;
          item.widthType="normal";
          return item;
        })
      }
      return arr;
    },
    getItemWidth(valList){
      const tableWidth = this.tablePosition.width - 56;
      let itemWidth = 0;
      const length = valList.length;
      itemWidth = tableWidth/length
      itemWidth = this.$fixedMath(itemWidth, 2)
      return itemWidth;
    },
    onCellChange(field, dataIndex, value) {
      const tableData = [...this.tableData];
      const target = tableData.find(item => item.field === field);
      if (target) {
        target[dataIndex] = value;
        // console.log(target, 'target');
        this.tableData = this.$deepclone(tableData);
      }
      // console.log(tableData, 'tableData');
      this.$emit("input", this.tableData);
      this.$emit("change", this.tableData);
    },
  },
  created () {
    this.rowDrop()
  },
  beforeDestroy () {
    if (this.sortable1) {
      this.sortable1.destroy()
    }
  },
};
</script>
<style lang="less" scoped>
/deep/::-webkit-scrollbar-track-piece {
  background-color: transparent;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0; // 横向滚动条
  height: 8px; // 纵向滚动条 必写
}
// 滚动条的滑块
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgba(144, 146, 152, 0.3);
}
.drag-btn {
  cursor: move;
  font-size: 12px;
}
/deep/ .vxe-body--row.sortable-ghost,.vxe-body--row.sortable-chosen {
  background-color: #dfecfb;
}

</style>
